import { Currencies } from '../types';
import {api} from './api';

export interface VendorProfile {
	id: number;
	description: string;
	address: string;
	legalName: string;
	taxId: string | null;
	receiveOrdersEmail: string | null;
	vendorContactEmail: string | null;
	website: string | null;
	currency: Currencies;
}

const BASE_URL = 'vendorProfiles';

export const vendorProfileApi = api.injectEndpoints({
	endpoints: (builder) => ({
		activateVendorProfile: builder.mutation<VendorProfile, Partial<VendorProfile>>({
			query: (data) => ({
				url: `${BASE_URL}/activate`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['VendorProfile'],
		}),
		deactivateVendorProfile: builder.mutation<void, void>({
			query: () => ({
				url: `${BASE_URL}/deactivate`,
				method: 'PUT',
			}),
			invalidatesTags: ['VendorProfile'],
		}),
		getCompanyVendorProfile: builder.query<VendorProfile | null, void>({
			query: () => ({
				url: `${BASE_URL}/getCompanyVendorProfile`,
				method: 'GET',
			}),
			providesTags: ['VendorProfile'],
		}),
		updateVendorProfile: builder.mutation<VendorProfile, Partial<VendorProfile>>({
			query: (data) => ({
				url: `${BASE_URL}/${data.id}`,
				method: 'PATCH',
				body: data,
			}),
			invalidatesTags: ['VendorProfile'],
		}),
	}),
});

export const { useGetCompanyVendorProfileQuery, useUpdateVendorProfileMutation, useDeactivateVendorProfileMutation, useActivateVendorProfileMutation } = vendorProfileApi;
